// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1E4TP","footer":"styles_footer__23gwD","passCodeTooltip":"styles_passCodeTooltip__NIsQn"};